import {Injectable} from '@angular/core';
import {FileService} from './file.service';
import {Prescription} from '@shared/models/prescription.model';
import {HttpClient, HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class PrescriptionService {

  constructor(
    private fileService: FileService,
    private http: HttpClient
  ) { }

  async getOpenPatientInformationSheet(prescriptionId: number): Promise<void> {
    const url = `/api/v1/prescription/${prescriptionId}/download`;
    await this.fileService.openPdf(url);
  }

  async getDownloadPatientInformationSheet(prescriptionId: number): Promise<void> {
    const url = `/api/v1/prescription/${prescriptionId}/download`;
    await this.fileService.downloadPdf(url);
  }

  getPrescription(prescriptionId: number): Promise<Prescription> {
    const url = `/api/v1/prescription/${prescriptionId}`;
    return this.http.get<Prescription>(url).toPromise();
  }

  getPrescriptions(
    page: number,
    size: number,
    startDateFrom?: number,
    startDateTo?: number,
    endDateFrom?: number,
    endDateTo?: number,
    onlyActive?: boolean
  ): Promise<Prescription[]> {
    const url = '/api/v1/prescription';
    let httpParams = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (startDateFrom) {
      httpParams = httpParams.set('startDateFrom', startDateFrom.toString());
    }

    if (startDateTo) {
      httpParams = httpParams.set('startDateTo', startDateTo.toString());
    }

    if (endDateFrom) {
      httpParams = httpParams.set('endDateFrom', endDateFrom.toString());
    }

    if (endDateTo) {
      httpParams = httpParams.set('endDateTo', endDateTo.toString());
    }

    if (onlyActive) {
      httpParams = httpParams.set('onlyActive', onlyActive.toString());
    }

    return this.http.get<Prescription[]>(url, {params: httpParams}).toPromise();
  }
}
